import { SxProps, Theme } from '@mui/material';

export const imageDpBestOfferSX: SxProps<Theme> = {
	objectFit: 'cover',
	height: {
		xs: 'auto',
		sm: '244px',
	},
};
